import { Form, Row, Col, Button, Icon, notification, Card } from "antd";
import React, { Component } from "react";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import Request, { LAPI_URL } from "../../../request";

const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
@Form.create()
class IntegratonSetup extends Component {
    state = {
        whatsappBusinessApi: false,
        commSettings: {},
        loading: false,
        cardLoading: false
    }

    loadInitialData = async () => {
        this.setState({ cardLoading: true });
        let res = await Request.getCommunicationSettings();
        this.setState({ cardLoading: false });
        if (res && !res.error && res.doc) {
            this.props.form.setFieldsValue(res.doc);
            this.setState({
                whatsappBusinessApi: res.doc.whatsappBusinessApi || false,
                commSettings: res.doc
            });
        }
    }

    handleFormSubmit = (e) => {
        e.preventDefault();
        let { form, onSuccess, isModal } = this.props;
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                values.businessId = activeUser.businessId;
                if (isModal) {
                    values.completeSetup = true;
                }
                this.setState({ loadig: true });
                let response = await Request.addCommunicationSettings(values);
                this.setState({ loadig: false });
                if (response && response.success) {
                    notification.success({
                        message: isModal ? 'Congratulations! Your System Setup has been Completed' : response.message
                    })
                    if (onSuccess && isModal) {
                        onSuccess();
                    }
                } else {
                    notification.error({
                        message: response.message
                    })
                }
            }
        })
    }

    onPrev = () => {
        this.props.onPrev();
    }


    componentDidMount() {
        this.loadInitialData()
    }

    render() {
        let { form: { setFieldsValue, getFieldDecorator }, isModal } = this.props;
        let { whatsappBusinessApi, loading, cardLoading } = this.state;
        const smtpSchema = {
            fields: [
                { label: 'SMTP Provider', key: 'smtpProvider' },
                { label: 'SMTP Port', key: 'smtpPort' },
                { label: 'SMTP Username', key: 'smtpUsername' },
                { label: 'SMTP Password', key: 'smtpPassword', type: 'password' },
                { label: 'From Name', key: 'companyName' },
                { label: 'From Email', key: 'fromEmail' }
            ]
        }

        const whatsappSchema = {
            fields: [
                { label: 'Whatsapp Business Api', key: 'whatsappBusinessApi', type: 'switch', onChange: v => { this.setState({ whatsappBusinessApi: v }); setFieldsValue({ whatsappBusinessApi: v }); } },
                { label: 'Whatsapp Number', key: 'whatsappApiNumber', hidden: !whatsappBusinessApi },
                { label: 'Fetch Template Url', key: 'fetchTemplateUrl', hidden: !whatsappBusinessApi },
                { label: 'Api Url', key: 'whatsApiUrl' },
                { label: 'Api Token', key: 'whatsApiToken' },

            ]
        }

        const smsSchema = {
            fields: [
                { label: 'SMS Api Url', key: 'smsApiUrl', type: 'textarea', rows: '2' },
                { label: 'OTP Template', key: 'StaffLoginOTP', type: 'textarea', rows: '2' }
            ]
        }
        return (
            <Card loadig={cardLoading}>
                <Form onSubmit={(e) => this.handleFormSubmit(e)}>
                    <Row gutter={24}>
                        <Col span={24}>
                            <div className="integration-block">
                                <h4 style={{ color: '#1890ff' }}><Icon type="mail" /> SMTP EMAIL</h4>
                                <GetAllFormFields apiurl={LAPI_URL} inputSchema={smtpSchema} getFieldDecorator={getFieldDecorator} />
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="integration-block" style={{ minHeight: '350px' }}>
                                <h4 style={{ color: '#25D366' }}><Icon type="whats-app" /> WHATSAPP</h4>
                                <GetAllFormFields apiurl={LAPI_URL} inputSchema={whatsappSchema} getFieldDecorator={getFieldDecorator} />
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="integration-block" style={{ minHeight: '350px' }}>
                                <h4 style={{ color: '#faad14' }}><Icon type="message" /> SMS GATEWAY</h4>
                                <GetAllFormFields apiurl={LAPI_URL} inputSchema={smsSchema} getFieldDecorator={getFieldDecorator} />
                            </div>
                        </Col>
                    </Row>
                    <div style={{ marginTop: 30, textAlign: 'right', borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
                        {isModal && <Button onClick={this.onPrev} style={{ height: 40, width: 100, marginRight: 10 }}>BACK</Button>}

                        <Button loading={loading} type="primary" htmlType="submit" style={{ height: 40, width: 160 }}>{isModal ? <span>COMPLETE SETUP <Icon type="check" /></span> : 'SAVE'}</Button>
                    </div>
                </Form>
            </Card>
        )
    }

}


export default IntegratonSetup;